// extracted by mini-css-extract-plugin
export default {"topsellingsList":"TopSelling_topsellingsList__L-wGJ","buttonWrap":"TopSelling_buttonWrap__jOXK4"};